import { useFetch } from '@portal/hooks';
import { ServiceUrl } from '@portal/lib';

export const useSendFinalOfferSMS = ({
  errorText,
  isErrorAlertMuted,
  onError,
  onSuccess,
} = {}) => {
  const [fetch, fetchRes] = useFetch({
    errorText,
    isErrorAlertMuted,
    onError,
    onSuccess,
  });

  const sendFinalOfferSMS = ({ leadId }) => {
    const config = {
      method: 'post',
      headers: { 'Content-Type': 'text/plain' },
      url: `${ServiceUrl}/SendOffer/${leadId}`,
      data: {},
    };

    return fetch(config);
  };

  return [sendFinalOfferSMS, fetchRes];
};
